/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative}mat-form-field[_ngcontent-%COMP%]{width:100%}.mat-form-field-label[_ngcontent-%COMP%]{display:none!important}.d-none[_ngcontent-%COMP%]{display:none}.selected-flag[_ngcontent-%COMP%]{position:absolute;top:29px;left:5px}.flag[_ngcontent-%COMP%]{width:21px;height:15px}  cc-phone-numbers-dropdown .mat-select-value{padding-left:25px}  .mat-form-field-label{display:none!important}  .mat-primary .mat-option.mat-selected:not(.mat-option-disabled){color:#fff!important}"];
export { styles as styles };
